musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.wasInFreespins = false;
musicManager.inBaseGameModifier = false;
musicManager.inBigWin = false;
musicManager.musicLevel = 1;

musicManager.ALLOFFLEVEL = [false, false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false, false];
musicManager.SINGLEWINLEVEL = [false, false, true, false, false];
musicManager.MULTIWINLEVEL = [false, false, false, true, false];
musicManager.REALLYBIGWINLEVEL = [false, false, false, true];

musicManager.FREESPINS_ALLOFF = [false, false, false];
musicManager.FREESPINS_BASE = [true, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.stepDownTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 1.5;
  musicManager.fadeBaseTimeOut = 4;

  musicManager.fadeBigWinTimeIn = 0.25;
  musicManager.fadeBigWinTimeOut = 0.25;

  musicManager.fadeSymWinTimeIn = 0.3;
  musicManager.fadeSymWinTimeOut = 0.3;

  musicManager.maxMusicVolume = 0.85;
  musicManager.maxFreeSpinsMusicVolume = 0.8;

  musicManager.baseMusic = ['bwTheme0', 'bwTheme1', 'bwTheme2', 'bwTheme3'];

  musicManager.basePlaying = [false, false, false, false];

  musicManager.baseID = [];
  musicManager.gambleSpin = undefined;
  musicManager.gambleSpinVolume = 0.4;

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.freeSpinsMusic = ['freeSpinsLoop0', 'freeSpinsLoop1', 'freeSpinsLoop2'];

  musicManager.fsPlaying = [false, false, false, false];

  musicManager.freeSpinsID = [];
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(soundManager.play(musicManager.freeSpinsMusic[j]));
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  musicManager.gambleSpin = soundManager.play('gambleTheme');
  soundManager.setVolume(0, musicManager.gambleSpin);

  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onSymbolWinlineStart = function () {
  if (musicManager.inFreespins) {
    musicManager.previouslyPlayingBeforeFade = musicManager.fsPlaying;
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut
    );
  } else {
    musicManager.previouslyPlayingBeforeFade = musicManager.basePlaying;
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeSymWinTimeIn, musicManager.fadeSymWinTimeOut);
  }
};
musicManager.onSymbolWinlineEnd = function () {
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeIOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut
    );
  }
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameStart = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.idle = false;

  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;
    musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;
  var spinsRemaining = autoplayManager.getRemainingRounds();
  if (!musicManager.wasInFreespins && spinsRemaining === 0) {
    if (musicManager.inBigWin === false) {
      musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, function () {
        musicManager.stepDown(true);
      });
    } else {
      musicManager.inBigWin = false;
      musicManager.stepDownTimer = timerManager.addTimer(100, undefined, function () {
        musicManager.fadeLevels(
          musicManager.REALLYBIGWINLEVEL,
          musicManager.fadeBigWinTimeIn,
          musicManager.fadeBigWinTimeOut
        );
        // soundManager.stop(musicManager.REALLYBIGWINLEVEL);

        musicManager.stepDown(true);
      });
    }
  }
};

musicManager.stepDown = function () {
  if (musicManager.basePlaying === musicManager.REALLYBIGWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, musicManager.stepDown);
    musicManager.fadeLevels(musicManager.MULTIWINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else if (musicManager.basePlaying === musicManager.MULTIWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, musicManager.stepDown);
    musicManager.fadeLevels(musicManager.SINGLEWINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else if (musicManager.basePlaying === musicManager.SINGLEWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, musicManager.stepDown);
    musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else if (musicManager.basePlaying === musicManager.SPINLEVEL) {
    timerManager.stop(musicManager.stepDownTimer);
    musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play('bigWinTheme');

  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBigWinTimeIn, musicManager.fadeBigWinTimeOut);
  }
};

musicManager.fadeBigWin = function (newVolume) {
  soundManager.setVolume(newVolume, musicManager.bigWinID);
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime) {
  if (musicManager.inFreespins) return;
  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeIn[i]);
  }

  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOut[i]);
  }

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.fade(musicManager.maxFreeSpinsMusicVolume, fadeInTime, musicManager.soundsToFadeInFS[i]);
  }

  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fsPlaying = levels;
};

musicManager.restartBaseMusic = function () {
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.restartFreeSpins = function () {
  musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onFreespinsIntro = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, 0.5);
  soundManager.fade(musicManager.gambleSpinVolume, 1, musicManager.gambleSpin);
  musicManager.playing = false;
};

musicManager.onFreeSpinsCollect = function () {
  soundManager.setVolume(0, musicManager.gambleSpin);
  soundManager.fade(musicManager.gambleSpinVolume, 4, musicManager.gambleSpin);
};

musicManager.onFreespinsStart = function () {
  // Here we stop the freespins intro music and play the freespins standard music
  soundManager.fade(0, 0.5, musicManager.gambleSpin);
  timerManager.stop(musicManager.stepDownTimer);
  //musicManager.resetfreeSpinsLevel();
  musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
  musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);

  musicManager.inFreespins = true;
  musicManager.playing = false;
};

musicManager.freeSpinsNextLevel = function () {
  var changed = false;

  if (musicManager.freeSpinsLevel === musicManager.FREESPINS_BASE) {
    musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
    changed = true;
  } else if (musicManager.freeSpinsLevel === musicManager.FREESPINS_LEVEL1) {
    musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL2;
    changed = true;
  }

  if (changed) {
    musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.onFreespinsEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  soundManager.play('bonusWon');
  musicManager.inFreespins = false;
  musicManager.wasInFreeSpins = true;
  musicManager.fadeFSLevels(musicManager.FREESPINS_ALLOFF, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  //musicManager.stepDownTimer  = timerManager.addTimer(4000, musicManager.fadeLevels( musicManager.REALLYBIGWINLEVEL, musicManager.fadeBigWinTimeIn, musicManager.fadeBigWinTimeOut, 1, 0 ) , musicManager.stepDown(true));
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onFreespinsLostGambleEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  soundManager.fade(0, 1, musicManager.gambleSpin);
  musicManager.inFreespins = false;
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.setMusicLevel = function (level) {
  musicManager.musicLevel = level;
};

musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager.inFreespins) return;
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);
